import router from '@/router/index.js'
import store from '@/store'
import { getToken, setNextPage } from '@/axios/cookies.js'

router.beforeEach((to, from, next) => {
  const token = getToken()
  const whiteList = [
    '/',
    '/indexpage',
    '/productDetail',
    '/indexpage/index',
    '/indexpage/productlist', // 商品列表
    '/myLogin',
    '/jumpLogin'
  ]
  if (token) {
    console.log(token,'ok-token');
    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) {

      next()
    } else {
      console.log("登录触发234:permission.js");
     // store.commit('setLoginVisible', true)

     setNextPage(to.fullPath)
      //跳转路由登入
     next('/myLogin')
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/permission.js